import React from "react";
import { icons } from "../icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Col, Container, Row } from "react-bootstrap";

const Project = (props) => {
  const { name, website, summary, github, media } = props;
  return (
    <>
      <Container>
        <Row>
          <Col>
            <a href={website} target="_blank" rel="noopener noreferrer">
              <h2 style={{ fontSize: "2rem", fontWeight: "300" }}>{name}</h2>
            </a>
            <div style={{ textAlign: "center" }}>
              {github ? (
                <a href={github} target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon
                    style={{ fontSize: "35px", textAlign: "center" }}
                    size={"lg"}
                    icon={icons.Github}
                  />
                </a>
              ) : (
                "private repo"
              )}
            </div>
            {summary && <div>{summary}</div>}
            {media && (
              <div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <img
                    src={media.source}
                    style={{ maxHeight: "500px" }}
                    alt={`${name} animated demo`}
                  />
                </div>
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Project;
